"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BPMChangeCommand = void 0;
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
/**
 * Changes song's BPM. Can be placed in the middle of a measure, therefore it is
 * necessary to calculate milliseconds per measure value for each note.
 *
 * **Example:**
 *
 * ```
 * #BPMCHANGE 115
 * 2344
 * #BPMCHANGE 125
 * 3443,
 * ```
 */
class BPMChangeCommand extends Command_1.Command {
    constructor(value) {
        super(CommandType_1.CommandType.BPMChange);
        this.value = value;
    }
    static parse(args) {
        if (args.length === 0) {
            return undefined;
        }
        const value = parseInt(args[0], 10);
        if (isNaN(value)) {
            return undefined;
        }
        return new BPMChangeCommand(value);
    }
    toString() {
        return `${super.toString()} ${this.value}`;
    }
}
exports.BPMChangeCommand = BPMChangeCommand;
